import * as types from '../constants/ActionTypes';
import { Toast } from '@updox/ui-components';
import { isDirectMessage } from '../helpers/ChatUtils';
import {
  SEND_TO_INBOX_RESULT_TOAST_FAIL_PREFIX,
  SEND_TO_INBOX_RESULT_TOAST_SUCCESS_PREFIX,
  SEND_TO_INBOX_RESULT_TOAST_EXPORT,
  SEND_TO_INBOX_RESULT_TOAST_DM,
  SEND_TO_INBOX_RESULT_TOAST_CHANNEL,
} from '../constants/StringConstants';



const buildNotificationBody = (chat) => {
  return `${SEND_TO_INBOX_RESULT_TOAST_EXPORT} ${isDirectMessage(chat) ? SEND_TO_INBOX_RESULT_TOAST_DM : SEND_TO_INBOX_RESULT_TOAST_CHANNEL} ${chat.name}`;
};

/**
 * A wrapping call for building and sending the PDF.
 *
 * @param chatId
 * @returns {{payload: *, type: string}}
 */
export const buildAndSendExportToInbox = chatId => ({
  type: types.PDF_EXPORT_MESSAGES,
  payload: chatId,
});

/**
 * Starts building a PDF based on the selectedMessages reducer.
 *
 * @param chatId
 * @returns {{payload: {}, type: string}}
 */
export const startExport = chatId => ({
  type: types.PDF_BUILD_START,
  payload: {
    [chatId]: {
      pdf: null,
    },
  },
});

/**
 * Stores the PDF document model (react-pdf) in redux after successfully building.
 *
 * @param chatId
 * @param pdf the react-pdf document model
 * @returns {{payload: {}, type: string}}
 */
export const finishExport = (chatId, pdf) => ({
  type: types.PDF_BUILD_FINISH,
  payload: {
    [chatId]: {
      pdf,
    },
  },
});

/**
 * Makes the API call to send the PDF and any attachments.
 *
 * @param chatId
 * @returns {{payload: {}, type: string}}
 */
export const sendExportToInbox = chatId => ({
  type: types.PDF_SEND_TO_INBOX,
  payload: chatId,
});

/**
 * Shows a success notification and is a noop on the PDF state.
 *
 * @param chat
 * @returns {{payload: {}, type: string}}
 */
export const successfulExportToInbox = (chat) => {
  Toast.toast(`${SEND_TO_INBOX_RESULT_TOAST_SUCCESS_PREFIX} ${buildNotificationBody(chat)}`, {
    type: Toast.ToastType.SUCCESS,
  });

  return {
    type: types.PDF_SEND_TO_INBOX_SUCCESS,
    payload: {
      [chat.id]: {
        isSending: false,
      },
    },
  };
};

/**
 * Shows a failed notification and is a noop on the PDF state.
 *
 * @param chat
 * @returns {{payload: {}, type: string}}
 */
export const failExportToInbox = (chat) => {
  Toast.toast(`${SEND_TO_INBOX_RESULT_TOAST_FAIL_PREFIX} ${buildNotificationBody(chat)}`, {
    type: Toast.ToastType.ERROR,
  });

  return {
    type: types.PDF_SEND_TO_INBOX_FAIL,
    payload: {
      [chat.id]: {
        isSending: false,
      },
    },
  };
};
